import { View, Text } from "react-native";
import { useAssessmentQuestionContext } from "../context/AssessmentQuestionContext";

export function AssessmentQuestionInstructions() {
  const { question } = useAssessmentQuestionContext();
  const hasInstructions =
    !!question.instructions && question.instructions.length > 0;
  if (!hasInstructions) return null;

  return (
    <View>
      {question.instructions!.map((instr) => (
        <View key={instr.id} className="flex flex-col">
          <Text className="mb-2">{instr.description}</Text>
        </View>
      ))}
    </View>
  );
}
